/*
Assignments have a name and are then an ordered array
of items, sets, lessons, and courses in a stack.
Eventually they can have logic added to them or have
automatic logic applied to them.

Top row:

Create New Assignment or Create Existing Assignment to Modify

In this view, you can create an assignment or edit an assignment.
The major visual element is a stack of items that can be
re-ordered, deleted from, or added to.

Eventually will need to be able to search through items by properties.

below, units is an array of items, sets, lessons, and courses that make up an assignment

assignment: {
  assignmentId: '',
  assignmentName: '',
  createdDate: 0,
  lastModifiedDate: 0,
  units: [],
  assignmentCreator: '',
  usersAssigned: {},
}

*/

const AM_FETCHING_ASSIGNMENTS = 'AM_FETCHING_ASSIGNMENTS'
const AM_FETCHING_ASSIGNMENTS_SUCCESS = 'AM_FETCHING_ASSIGNMENTS_SUCCESS'
const AM_FETCHING_ASSIGNMENTS_ERROR = 'AM_FETCHING_ASSIGNMENTS_ERROR'
const AM_FETCHING_ITEMS = 'AM_FETCHING_ITEMS'
const AM_FETCHING_ITEMS_SUCCESS = 'AM_FETCHING_ITEMS_SUCCESS'
const AM_FETCHING_ITEMS_ERROR = 'AM_FETCHING_ITEMS_ERROR'
const AM_SET_ACTIVE_ASSIGNMENT = 'AM_SET_ACTIVE_ASSIGNMENT'
const AM_CREATE_NEW_ASSIGNMENT = 'AM_CREATE_NEW_ASSIGNMENT'
const AM_SET_ACTIVE_ASSIGNMENT_NAME = 'AM_SET_ACTIVE_ASSIGNMENT_NAME'
const AM_SET_ACTIVE_ASSIGNMENT_UNITS = 'AM_SET_ACTIVE_ASSIGNMENT_UNITS'
const AM_ADD_ACTIVE_ASSIGNMENT_UNIT = 'AM_ADD_ACTIVE_ASSIGNMENT_UNIT'
const AM_DELETE_ACTIVE_ASSIGNMENT_UNIT = 'AM_DELETE_ACTIVE_ASSIGNMENT_UNIT'
const AM_SELECT_ITEM = 'AM_SELECT_ITEM'
const AM_SET_SAVING_TRUE = 'AM_SET_SAVING_TRUE'
const AM_SAVING_SUCCESS = 'AM_SAVING_SUCCESS'
const AM_SAVING_ERROR = 'AM_SAVING_ERROR'
const AM_FETCHING_USERS = 'AM_FETCHING_USERS'
const AM_FETCHING_USERS_SUCCESS = 'AM_FETCHING_USERS_SUCCESS'
const AM_FETCHING_USERS_ERROR = 'AM_FETCHING_USERS_ERROR'
const AM_ADDING_ASSIGNMENT_TO_USER = 'AM_ADDING_ASSIGNMENT_TO_USER'
const AM_ADDING_ASSIGNMENT_TO_USER_SUCCESS = 'AM_ADDING_ASSIGNMENT_TO_USER_SUCCESS'
const AM_ADDING_ASSIGNMENT_TO_USER_ERROR = 'AM_ADDING_ASSIGNMENT_TO_USER_ERROR'
const AM_REMOVING_ASSIGNMENT_FROM_USER = 'AM_REMOVING_ASSIGNMENT_FROM_USER'
const AM_REMOVING_ASSIGNMENT_FROM_USER_SUCCESS = 'AM_REMOVING_ASSIGNMENT_FROM_USER_SUCCESS'
const AM_REMOVING_ASSIGNMENT_FROM_USER_ERROR = 'AM_REMOVING_ASSIGNMENT_FROM_USER_ERROR'
const AM_SET_NO_CHANGES_FALSE = 'AM_SET_NO_CHANGES_FALSE'
const AM_SET_ASSIGNMENT_TYPE = 'AM_SET_ASSIGNMENT_TYPE'
const AM_SET_NULL_ASSIGNMENT = 'AM_SET_NULL_ASSIGNMENT'
const AM_FETCHING_NODES = 'AM_FETCHING_NODES'
const AM_FETCHING_NODES_SUCCESS = 'AM_FETCHING_NODES_SUCCESS'
const AM_FETCHING_NODES_ERROR = 'AM_FETCHING_NODES_ERROR'
const AM_DELETING_SUCCESS = 'AM_DELETING_SUCCESS'
 
export function fetchingAssignments() {
  return {
    type: AM_FETCHING_ASSIGNMENTS,
  }
}

export function fetchingAssignmentsSuccess(assignments) {
  return {
    type: AM_FETCHING_ASSIGNMENTS_SUCCESS,
    assignments,
  }
}

export function fetchingAssignmentsError(error) {
  return {
    type: AM_FETCHING_ASSIGNMENTS_ERROR,
    error,
  }
}

export function fetchingItems() {
  return {
    type: AM_FETCHING_ITEMS
  }
}

export function fetchingItemsSuccess(items) {
  return {
    type: AM_FETCHING_ITEMS_SUCCESS,
    items,
  }
}

export function fetchingItemsError(error) {
  return {
    type: AM_FETCHING_ITEMS_ERROR,
    error,
  }
}

export function setActiveAssignment(assignment) {
  return {
    type: AM_SET_ACTIVE_ASSIGNMENT,
    assignment,
  }
}

export function createNewAssignment({timestamp, assignmentId, assignmentCreator}) {
  return {
    type: AM_CREATE_NEW_ASSIGNMENT,
    timestamp,
    assignmentCreator,
    assignmentId,
  }
}

export function setActiveAssignmentName({assignmentName, timestamp}) {
  return {
    type: AM_SET_ACTIVE_ASSIGNMENT_NAME,
    assignmentName,
  }
}

export function setActiveAssignmentUnits({assignmentUnits, timestamp}) {
  return {
    type: AM_SET_ACTIVE_ASSIGNMENT_UNITS,
    assignmentUnits,
    timestamp,
  }
}

export function addActiveAssignmentUnit ({assignmentUnit, timestamp}) {
  return {
    type: AM_ADD_ACTIVE_ASSIGNMENT_UNIT,
    assignmentUnit,
    timestamp,
  }
}

export function deleteActiveAssignmentUnit ({index, timestamp}) {
  return {
    type: AM_DELETE_ACTIVE_ASSIGNMENT_UNIT,
    index,
    timestamp,
  }
}

export function selectItem (itemId) {
  return {
    type: AM_SELECT_ITEM,
    itemId,
  }
}

export function setSavingTrue () {
  return {
    type: AM_SET_SAVING_TRUE,
  }
}

export function deletingSuccess() {
  return {
    type: AM_DELETING_SUCCESS,
  }
}

export function savingSuccess () {
  return {
    type: AM_SAVING_SUCCESS,
  }
}

export function savingError (error) {
  return {
    type: AM_SAVING_ERROR,
    error,
  }
}

export function fetchingUsers () {
  return {
    type: AM_FETCHING_USERS,
  }
}

export function fetchingUsersSuccess(users) {
  return {
    type: AM_FETCHING_USERS_SUCCESS,
    users,
  }
}

export function fetchingUsersError(error) {
  return {
    type: AM_FETCHING_USERS_ERROR,
    error,
  }
}

export function addingAssignmentToUser() {
  return {
    type: AM_ADDING_ASSIGNMENT_TO_USER,
  }
}

export function addingAssignmentToUserSuccess(userId) {
  return {
    type: AM_ADDING_ASSIGNMENT_TO_USER_SUCCESS,
    userId,
  }
}

export function addingAssignmentToUserError(error) {
  return {
    type: AM_ADDING_ASSIGNMENT_TO_USER_ERROR,
    error,
  }
}

export function removingAssignmentFromUser() {
  return {
    type: AM_REMOVING_ASSIGNMENT_FROM_USER,
  }
}

export function removingAssignmentFromUserSuccess(userId) {
  return {
    type: AM_REMOVING_ASSIGNMENT_FROM_USER_SUCCESS,
    userId,
  }
}

export function removingAssignmentFromUserError (error) {
  return {
    type: AM_REMOVING_ASSIGNMENT_FROM_USER_ERROR,
    error,
  }
}

export function setNoChangesFalse() {
  return {
    type: AM_SET_NO_CHANGES_FALSE,
  }
}

export function setAssignmentType (assignmentType) {
  return {
    type: AM_SET_ASSIGNMENT_TYPE,
    assignmentType,
  }
}

export function setNullAssignment() {
  return {
    type: AM_SET_NULL_ASSIGNMENT,
  }
}

export function fetchingNodes() {
  return {
    type: AM_FETCHING_NODES,
  }
}

export function fetchingNodesSuccess (nodes) {
  return {
    type: AM_FETCHING_NODES_SUCCESS,
    nodes,
  }
}

export function fetchingNodesError (error) {
  return {
    type: AM_FETCHING_NODES_ERROR,
    error,
  }
}


const initialState = {
  assignmentList: null,
  items: null,
  assignmentId: '',
  isFetchingItems: false,
  isFetchingAssignments: false,
  isSaving: false,
  noChanges: true,
  assignment: {},
  error: '',
  selectedItem: '',
  isFetchingUsers: false,
  isSavingUserAssignment: false,
  users: null,
  assignmentType: '',
  nodes: null,
  isFetchingNodes: false,
}

export function assignmentsManage (state = initialState, action) {
  switch (action.type) {
    case AM_FETCHING_ASSIGNMENTS :
      return {
        ...state,
        isFetchingAssignments: true,
        error: '',
      }
    case AM_FETCHING_ASSIGNMENTS_SUCCESS :
      return {
        ...state,
        isFetchingAssignments: false,
        error: '',
        assignmentList: action.assignments,
      }
    case AM_FETCHING_ASSIGNMENTS_ERROR :
      return {
        ...state,
        isFetchingAssignments: false,
        error: '',
        assignmentList: null,
      }
    case AM_FETCHING_ITEMS :
      return {
        ...state,
        isFetchingItems: true,
        error: '',
      }
    case AM_FETCHING_ITEMS_SUCCESS : 
      return {
        ...state,
        items: action.items,
        isFetchingItems: false,
        error: '',
      }
    case AM_FETCHING_ITEMS_ERROR :
      return {
        ...state,
        items: null,
        isFetchingItems: false,
        error: action.error,
      }
    case AM_SET_ACTIVE_ASSIGNMENT :
      return {
        ...state,
        assignment: action.assignment,
        assignmentId: action.assignment.assignmentId,
        assignmentType: action.assignment.assignmentType ? action.assignment.assignmentType : '',
      }
    case AM_SET_NULL_ASSIGNMENT :
      return {
        ...state,
        assignment: null,
        assignmentId: '',
        assignmentType: '',
      }
    case AM_CREATE_NEW_ASSIGNMENT :
      return {
        ...state,
        assignmentId: action.assignmentId,
        assignment: {
          assignmentId: action.assignmentId,
          assignmentName: '',
          createdDate: action.timestamp,
          lastModifiedDate: action.timestamp,
          units: [],
          assignmentCreator: '',
        },
        noChanges: false,
        assignmentType: '',
      }
    case AM_SET_ACTIVE_ASSIGNMENT_NAME : 
      return {
        ...state,
        assignment: {
          ...state.assignment,
          assignmentName: action.assignmentName,
          lastModifiedDate: action.timestamp,
        },
        noChanges: false,
      }
    case AM_SET_ACTIVE_ASSIGNMENT_UNITS :
      return {
        ...state,
        noChanges: false,
        assignment: {
          ...state.assignment,
          units: action.assignmentUnits,
          lastModifiedDate: action.timestamp,
        },
      }
    case AM_ADD_ACTIVE_ASSIGNMENT_UNIT :
      let newUnits
      if (state.assignment.units) {
        newUnits = state.assignment.units.concat(action.assignmentUnit)
      } else {
        newUnits = [action.assignmentUnit]
      }
      return {
        ...state,
        noChanges: false,
        assignment: {
          ...state.assignment,
          units: newUnits,
          lastModifiedDate: action.timestamp,
        },
      }
    case AM_DELETE_ACTIVE_ASSIGNMENT_UNIT: 
      return {
        ...state,
        noChanges: false,
        assignment: {
          ...state.assignment,
          units: state.assignment.units.slice(0, state.assignment.units.length),
          lastModifiedDate: action.timestamp,
        },
      }
    case AM_SELECT_ITEM : 
      return {
        ...state,
        selectedItem: action.itemId,
      }
    case AM_SET_SAVING_TRUE :
      return {
        ...state,
        isSaving: true,
        error: '',
      }
    case AM_DELETING_SUCCESS : 
      return {
        ...state,
        isSaving: false,
        error: '',
        assignment: {},
        assignmentId: '',
        noChanges: true,
        selectedItem: '',
      }
    case AM_SAVING_SUCCESS :
      return {
        ...state,
        isSaving: false,
        error: '',
        noChanges: true,
      }
    case AM_SAVING_ERROR : 
      return {
        ...state,
        isSaving: false,
        error: action.error,
      }
    case AM_FETCHING_USERS :
      return {
        ...state,
        isFetchingUsers: true,
      }
    case AM_FETCHING_USERS_SUCCESS :
      return {
        ...state,
        isFetchingUsers: false,
        users: action.users,
        error: '',
      }
    case AM_FETCHING_USERS_ERROR :
      return {
        ...state,
        isFetchingUsers: false,
        error: action.error,
      }
    case AM_ADDING_ASSIGNMENT_TO_USER :
      return {
        ...state,
        isSavingUserAssignment: true,
      }
    case AM_ADDING_ASSIGNMENT_TO_USER_SUCCESS :
      return {
        ...state,
        isSavingUserAssignment: false,
        userId: action.userId,
        error: '',
      }
    case AM_ADDING_ASSIGNMENT_TO_USER_ERROR :
      return {
        ...state,
        isSavingUserAssignment: false,
        error: action.error,
      }
    case AM_REMOVING_ASSIGNMENT_FROM_USER :
      return {
        ...state,
        isSavingUserAssignment: true,
      }
    case AM_REMOVING_ASSIGNMENT_FROM_USER_SUCCESS :
      return {
        ...state,
        isSavingUserAssignment: false,
        userId: action.userId,
        error: '',
      }
    case AM_REMOVING_ASSIGNMENT_FROM_USER_ERROR :
      return {
        ...state,
        isSavingUserAssignment: false,
        error: action.error,
      }
    case AM_SET_NO_CHANGES_FALSE :
      return {
        ...state,
        noChanges: false,
      }
    case AM_SET_ASSIGNMENT_TYPE :
      return {
        ...state,
        assignmentType: action.assignmentType, 
      }
    case AM_FETCHING_NODES :
      return {
        ...state,
        isFetchingNodes: true,
      }
    case AM_FETCHING_NODES_SUCCESS :
      return {
        ...state,
        isFetchingNodes: false,
        nodes: action.nodes,
      }
    case AM_FETCHING_NODES_ERROR :
      return {
        ...state,
        isFetchingNodes: false,
        error: action.error,
      }
    default :
      return state
  }
}


// WEBPACK FOOTER //
// ./src/redux/modules/assignmentsManage.js